module.exports = __webpack_public_path__ + "static/img/adduser.3bf5546c.png";